import React from 'react';
import { MapPin } from 'lucide-react';

const citySeoContent = [
  {
    city: "Bruxelles",
    title: "Marabout à Bruxelles",
    description: "Vous cherchez un marabout sérieux à Bruxelles ? Le marabout de Bruxelles offre ses services professionnels dans toute la capitale. Retour affectif, envoûtement d'amour et magie blanche disponibles pour les habitants de Bruxelles."
  },
  {
    city: "Anvers",
    title: "Marabout à Anvers",
    description: "Marabout professionnel à Anvers (Antwerpen). Le marabout d'Anvers est spécialisé dans le retour de l'être aimé et les rituels de magie rouge. Services disponibles pour toute la région d'Anvers."
  },
  {
    city: "Gand",
    title: "Marabout à Gand",
    description: "Le marabout de Gand (Gent) intervient pour tous vos problèmes sentimentaux. Marabout sérieux à Gand avec plus de 20 ans d'expérience. Consultations disponibles à Gand et environs."
  },
  {
    city: "Liège",
    title: "Marabout à Liège",
    description: "Vous recherchez un marabout à Liège ? Le marabout de Liège est reconnu pour son efficacité. Spécialiste du retour affectif à Liège, récupérer son ex et envoûtement d'amour."
  },
  {
    city: "Charleroi",
    title: "Marabout à Charleroi",
    description: "Marabout professionnel à Charleroi. Le marabout de Charleroi offre des services de voyance, magie blanche et retour d'affection. Interventions rapides à Charleroi et région."
  },
  {
    city: "Bruges",
    title: "Marabout à Bruges",
    description: "Marabout sérieux à Bruges (Brugge). Le marabout de Bruges pratique la magie africaine traditionnelle. Services de retour affectif disponibles à Bruges."
  },
  {
    city: "Namur",
    title: "Marabout à Namur",
    description: "Le marabout de Namur intervient pour résoudre vos problèmes amoureux. Marabout efficace à Namur spécialisé dans les rituels de retour de l'être aimé."
  },
  {
    city: "Louvain",
    title: "Marabout à Louvain",
    description: "Marabout professionnel à Louvain (Leuven). Le marabout de Louvain propose des consultations discrètes. Services de magie blanche et rouge à Louvain."
  },
  {
    city: "Mons",
    title: "Marabout à Mons",
    description: "Vous cherchez un marabout à Mons ? Le marabout de Mons est spécialisé dans le retour affectif et l'envoûtement d'amour. Interventions à Mons et environs."
  }
];

const CitiesSEO = () => {
  return (
    <section className="py-16 md:py-32 px-4 relative overflow-hidden bg-gradient-to-b from-black via-gray-900/50 to-black">
      <div className="absolute bottom-1/4 left-1/3 w-96 h-96 bg-amber-600/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            Marabout dans <span className="gold-text">Toutes les Villes</span> de Belgique
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto serif-font">
            Services professionnels de maraboutage disponibles dans toutes les grandes villes belges
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {citySeoContent.map((item, index) => (
            <div 
              key={index}
              className="card-hover glass rounded-3xl p-8"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <MapPin className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 display-font">{item.title}</h3>
              <p className="text-gray-300 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
        
        {/* SEO Text Block */}
        <div className="max-w-5xl mx-auto glass rounded-3xl p-10">
          <h3 className="text-3xl font-bold text-white mb-6 display-font text-center">
            Services de Maraboutage Professionnel en Belgique
          </h3>
          <div className="text-gray-300 leading-relaxed space-y-4">
            <p>
              <strong className="text-yellow-500">Les marabouts de Bruxelles, Anvers, Gand et Liège</strong> sont à votre service pour tous vos besoins spirituels. 
              Que vous cherchiez un <strong>marabout à Bruxelles</strong> pour un retour affectif, un <strong>marabout de Liège</strong> pour 
              récupérer votre ex, ou un <strong>marabout sur Anvers</strong> pour de la magie blanche, nous intervenons dans toute la Belgique.
            </p>
            <p>
              Le <strong>marabout de Charleroi</strong> et le <strong>marabout à Namur</strong> offrent des services identiques avec la même efficacité. 
              Les <strong>marabouts de Gand</strong> et les <strong>marabouts à Bruges</strong> pratiquent la magie africaine traditionnelle avec 
              plus de 20 ans d'expérience.
            </p>
            <p>
              Vous habitez à <strong>Louvain, Mons, Alost, Malines</strong> ou <strong>La Louvière</strong> ? Le marabout intervient également dans 
              ces villes pour des rituels de retour de l'être aimé, envoûtement d'amour, et protection spirituelle. Les <strong>marabouts de Courtrai</strong>, 
              <strong>Hasselt</strong> et <strong>Ostende</strong> sont disponibles pour consultations.
            </p>
            <p>
              Services étendus à <strong>Mouscron, Tournai, Genk, Seraing, Verviers</strong> et toutes les communes belges. 
              Que vous cherchiez un <strong>marabout de Roulers</strong>, un <strong>marabout à Beveren</strong>, ou un <strong>marabout sur Dendermonde</strong>, 
              nos services couvrent l'ensemble du territoire belge avec discrétion et efficacité.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CitiesSEO;